import { gql } from '@apollo/client';
import type { Segment } from '@fixter/i18n';

export interface QueryGetProductGroups {
  readonly getProductGroups: {
    readonly productSkuList: string[];
    readonly groupSlug: string;
  }[];
}

export interface QueryGetProductGroupsVariables {
  readonly segment: Segment;
}
export const QUERY_GET_PRODUCT_GROUPS = gql`
  query GetProductGroups($segment: String) {
    getProductGroups(catalog: "repairs", segment: $segment) {
      groupSlug
      productSkuList
    }
  }
`;
